export class InspirationRoomTipsModel {
  id: number;
  absoluteX: number;
  absoluteY: number;
  title: string;
  description: string;
  createdById: string;
  inspirationRoomId: number;
}
